import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { SettingService, SiteSetting, Lang } from '../../../services/setting.service';


@Component({
  selector: 'app-topbar',
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './topbar.html',
  styleUrl: './topbar.css',
})
export class Topbar  implements OnInit, OnDestroy{
private settingSvc = inject(SettingService);
  private translate  = inject(TranslateService);

  setting: SiteSetting | null = null;
  currentLang: Lang = 'fr';
  year = new Date().getFullYear();

  private langSub?: Subscription;
   ngOnInit(): void {
    this.currentLang = (this.translate.currentLang as Lang) || 'fr';
    this.load(this.currentLang);

    // Recharger les settings quand la langue change → champs *_text à jour
    this.langSub = this.translate.onLangChange.subscribe(e => {
      this.currentLang = e.lang as Lang;
      this.load(this.currentLang);
    });
  }

  ngOnDestroy(): void {
    this.langSub?.unsubscribe();
  }

  private load(lang: Lang): void {
    this.settingSvc.getSettings(lang).subscribe({
      next: s => this.setting = s,
      error: err => console.error('top settings load error', err),
    });
  }

  /** Champ multilingue : tente lang courante, puis fr, puis premier non vide. */
  pickLang(obj: any): string {
    if (!obj) return '';
    if (typeof obj === 'string') return obj;
    return obj[this.currentLang] || obj.fr || Object.values(obj).find(v => !!v) as string || '';
  }
}
